import { render } from "./ReportCriterion.vue?vue&type=template&id=720e3e96&scoped=true"
import script from "./ReportCriterion.vue?vue&type=script&lang=js"
export * from "./ReportCriterion.vue?vue&type=script&lang=js"

import "./ReportCriterion.vue?vue&type=style&index=0&id=720e3e96&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-720e3e96"]])

export default __exports__